import {Component, inject, OnInit} from '@angular/core';
import {CoreService} from '../../../core/services/core.service';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {PatientFlagEntity} from '@xmedical/core';
import {PatientFlagsStore, PatientStore} from '../../../core/state';

@Component({
  selector: 'app-patient-flags-editor',
  standalone: false,

  templateUrl: './patient-flags-editor.component.html',
  styleUrl: './patient-flags-editor.component.scss'
})
export class PatientFlagsEditorComponent implements OnInit {

  private coreService = inject(CoreService);
  private patientStore = inject(PatientStore);
  protected patientFlagsStore = inject(PatientFlagsStore);

  flags: PatientFlagEntity[] = [];

  ngOnInit() {
    this.flags = this.coreService.patientFlags().sort((a, b) => a.id > b.id ? 1 : -1);
  }

  isSelected(flagId: number): boolean {
    return this.patientFlagsStore.items().some(flag => flag.flagId === flagId);
  }

  onSelectedChange(change: MatCheckboxChange, id: number) {
    if (change.checked) {
      this.patientStore.addFlag(id).subscribe(() => this.patientFlagsStore.reload());
    } else {
      this.patientStore.removeFlag(id).subscribe(() => this.patientFlagsStore.reload());
    }
  }
}
